export const step2 = {
  discountAndCampaign: 'Descontos e Campanhas',
  crossSell: 'Cross-sell',
  directDebt: 'Débito Direto',
  campaign: 'Campanha',
  noCampaign: 'Sem Campanha',
  sendToEmail: 'Enviar por E-mail',
  minPriceCampaign:
    'O prémio da fração, está abaixo do prémio mínimo. Por favor, escolha outro fracionamento.',
  table: {
    recommended: 'RECOMENDADO',
    baseCoverage: 'COBERTURA BASE',
    optionalCoverage: 'COBERTURAS OPCIONAIS',
    baseCoverageAlt: 'Cobertura base',
    optionalCoverageAlt: 'Coberturas Opcionais',
    sumInsured: 'CAPITAL ',
    excessDeductible: 'FRANQUIA ',
    annualyUtilization: '(aplicável na 1ª utilização em cada anuidade)',
  },
  generateReport: {
    selectionPacks: 'Selecione os packs que pretende imprimir*',
    packModules: 'Módulos a considerar*',
    btnGenerateReport: 'Gerar Relatório',
    fullName: 'Nome Completo*',
    phone: 'N.º telemóvel*',
    email: 'E-mail*',
    vatNumber: 'NIF*',
    simpleReport: 'RELATÓRIO SIMPLIFICADO',
  },
  report: {
    header: 'Documentos simulação',
    headerAlt: 'Simulação',
    subHeader:
      'Esta simulação é valida durante 30 dias e destina-se apenas para este Tomador',
    validation: 'Por favor preencha os campos necessários: ',
    simulationNumber: 'Nº simulação',
    ownerIdentification: 'Identificação do Tomador',
    availableDocumentation: 'Documentação disponível',
    warning: '* são campos de preenchimento obrigatório',
    nif: 'NIF,',
    email: ' E-mail,',
    name: ' Nome Completo,',
    phone: ' Telefone,',
    packs: ' Seleção de packs,',
    search: 'Por favor clique na lupa para pesquisar o NIF,',
    errors: {
      emailNotSent: 'Erro ao enviar e-mail',
      invalidName: 'Por favor introduza um valor válido para este campo',
      invalidPhone: 'Por favor introduza um valor válido para este campo',
      invalidFirstNameLength:
        'O nome da entidade não pode ser atualizado no sistema por exceder o limite máximo de caracteres.',
    },
  },
  info: {
    unlimited: 'Ilimitado',
    max: 'max',
    by: 'por',
  },
  footerbar: {
    toolTip:
      'Ao 1.º recibo acresce %{value}€ do custo da apólice (já inclui encargos legais)',
    animal: {
      one: 'Animal',
      other: 'Animais',
    },
    secure: {
      one: 'Seguro',
      other: 'Seguros',
    },
    generateReport: 'GERAR RELATÓRIO',
    recalculate: 'RECALCULAR',
    advance: 'AVANÇAR',
  },
}
